export const LEGAL_INFO = {
  brandName: 'TravelSoul',
  companyNameEn: 'IVI PRO DEVELOPMENT LTD',
  companyNameBg: 'ИВИ ПРО ДЕВЕЛОПМЕНТ ЕООД',
  supportEmail: 'support@travelsoul.love',
  website: 'https://travelsoul.love',
  registrationNumber: '208696622',
  vatNumber: 'Not VAT registered',
  registeredAddress: '29 Ekzarh Yosif Street, Floor 1, Apt. 1, 1000 Sofia, Bulgaria',
  phoneOrLiveContact: '+359889111035',
};

export const isLegalPlaceholder = (value) => (
  !value || String(value).startsWith('PLACEHOLDER_')
);
